module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/core-js/library/modules/_a-function.js
// module id = 134
// module chunks = 0